import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Typography } from '@repo/ui/Typography';
export function Title() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = css({
      display: "flex",
      justifyContent: "center",
      bg: "neutral.lightest",
      p: "1",
      w: "[100%]"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={t0}><Typography as="span" variant="text.bold" css={{
        display: "block",
        textAlign: "center"
      }}>Why are you looking for a new credit card?</Typography></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}